<section class="statement-dialog visible-ui">
  <div class="modal-header">
    <span class="close-banner" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </span>
  </div>
  <div class="modal-body visible-ui">
    <section class="makePaymentView container" id="productList-areax">
      <section id="leftCont-rightNav">
        <section class="spl">
          <section class="d-flex flex-column">
            <section class="logo-account statement-logo">
              <img src="img/Sanofi-Global-Header-logo.png" alt="vaccine_shop_canada"/>
            </section>

            <section class="float-left col-md-12 spl-add">
              <sanofi-statements-pdf-download
                [accountNumber]="accountNumber()"
                [isCustomerEmulated]="isCustomerEmulated()"
                [toDate]="statement.toDte"
                [onModalView]="true"
                [salesOrg]="salesOrg()"
                class="statementsFileDownload py-2 justify-content-start"
              />
              <span class="col-xs-12 col-sm-7 col-md-7 mb1 px0">
                @if (salesOrg()?.toLowerCase() === SalesOrg.US03US12.toLowerCase() || salesOrg()?.toLowerCase() === SalesOrg.US12US03.toLowerCase()) {
                  {{ "statementDisplay.sanofiAddress.bothSalesOrgs" | cxTranslate }}
                } @else {
                  {{
                    ['statementDisplay.sanofiAddress.line1', 'statementDisplay.sanofiAddress.bothSalesOrgs'] |
                    cxTranslate: { context: salesOrg()?.toLowerCase() }
                  }}
                  <br/>
                  {{ ['statementDisplay.sanofiAddress.line2', 'statementDisplay.sanofiAddress.bothSalesOrgs'] |
                  cxTranslate: { context: salesOrg()?.toLowerCase() }
                  }}
                  <br/>
                  {{ ['statementDisplay.sanofiAddress.line3', 'statementDisplay.sanofiAddress.bothSalesOrgs'] |
                  cxTranslate: { context: salesOrg()?.toLowerCase() }
                  }}
                  <br/>
                  {{ ['statementDisplay.sanofiAddress.line4', 'statementDisplay.sanofiAddress.bothSalesOrgs']
                  | cxTranslate: { context: salesOrg()?.toLowerCase() }
                  }}
                }
              </span>
              <span>&nbsp;</span>
              <section class="col-xs-12 col-sm-6 col-md-6 spl-accno px-0">
                <span class="col-xs-12 col-sm-8 col-md-8 px0">{{ "statementDisplay.account_number_label" | cxTranslate }}</span>
                <span class="col-xs-12 col-sm-4 col-md-4 px0 account-number-align">{{ accountNumber() }}</span>
                <span>&nbsp;</span>
              </section>
              <section class="col-xs-12 col-sm-6 col-md-6 spl-accno px-0">
                <span class="col-xs-12 col-sm-9 col-md-9 px0">{{ "statementDisplay.statement_date_label" | cxTranslate }}</span>
                <span class="col-xs-12 col-sm-3 col-md-3 px0 account-number-align">
                      {{ statement.toDte | date: "MM/dd/yyyy" }}
                    </span>
              </section>
            </section>
          </section>
          @if (!!allStatementData) {
            <section class="acc-order-details">
              <!--table starts-->
              <section>
                <section class="col-md-12">
                  <section id="example2_wrapper" class="dataTables_wrapper no-footer">
                    <section class="payment-section">
                      <table aria-describedby="creditsTable" id="applyCreditsTable" class="credits-table table table-striped">
                        <thead>
                        <tr>
                          <th scope="col">{{ "statementDisplay.document_date_label" | cxTranslate }}&nbsp;</th>
                          <th scope="col">{{ "statementDisplay.due_date_label" | cxTranslate }}</th>
                          <th scope="col">{{ "statementDisplay.trans_type_label" | cxTranslate }}</th>
                          <th scope="col">{{ "statementDisplay.document_number_label" | cxTranslate }}</th>
                          <th scope="col">{{ "statementDisplay.original_amount_label" | cxTranslate }}&nbsp;</th>
                          <th scope="col">{{ "statementDisplay.amount_due_label" | cxTranslate }}</th>
                          <th scope="col">{{ "statementDisplay.currency_label" | cxTranslate }}</th>
                          <th scope="col">{{ "statementDisplay.terms_of_payment_label" | cxTranslate }}</th>
                        </tr>
                        </thead>

                        <tbody>

                          @if (!allStatementData?.statementTableData || allStatementData?.statementTableData?.length === 0) {
                            <tr>
                              <td colspan="8">{{ "statementDisplay.no_data" | cxTranslate }}</td>
                            </tr>
                          }
                        <tr *ngFor="let stData of allStatementData?.statementTableData; let i = index" class="table-row-section">
                          <td>
                            <span>{{ CommonUtils.formatDate(stData?.documentDate, US_DATE_FORMAT, EU_DATE_FORMAT) }}</span>
                          </td>
                          <td>
                            <span>{{ CommonUtils.formatDate(stData?.dueDate, US_DATE_FORMAT, EU_DATE_FORMAT) }}</span>
                          </td>
                          <td>
                            <span>{{ stData?.transType }}</span>
                          </td>
                          <td>
                            <span>{{ stData?.documentNumber }}</span>
                          </td>
                          <td>
                                  <span>
                                    <span *ngIf="checkNegativeValue(stData)">(</span>
                                    {{ stData?.originalAmount | number:"1.2-2" }}
                                    <span *ngIf="checkNegativeValue(stData)">)</span>
                                  </span>
                          </td>
                          <td>
                            <span>
                              <span *ngIf="checkNegativeValue(stData)">(</span>
                              {{ stData?.amountDue | number:"1.2-2" }}
                              <span *ngIf="checkNegativeValue(stData)">)</span>
                            </span>
                          </td>
                          <td>
                            <span>{{ stData?.currency }}</span>
                          </td>
                          <td>
                            <span>{{ stData?.termsOfPayment }}</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <table aria-describedby="creditsTable" id="applyStatementdisplayTable" class="credits-table table table-striped no-print">
                        <tr class="sample-header">
                          <th scope="col"></th>
                          <th scope="col"></th>
                        </tr>
                        <tr *ngIf="!allStatementData?.statementTableData || allStatementData?.statementTableData?.length === 0">
                          <td colspan="4" class="two-column-lay header">{{ "statementDisplay.document_date_label" | cxTranslate }}</td>
                          <td colspan="8" class="no-data-align">{{ "statementDisplay.no_data" | cxTranslate }}</td>
                        </tr>
                        <tr *ngFor="let stData of allStatementData?.statementTableData; let i = index" class="table-row-section">
                          <td class="two-column-lay header">{{ "statementDisplay.document_date_label" | cxTranslate }}</td>
                          <td class="two-column-lay">
                            <span>{{ stData?.documentDate }}</span>
                          </td>
                          <td class="two-column-lay header">{{ "statementDisplay.due_date_label" | cxTranslate }}</td>
                          <td class="two-column-lay">
                            <span>{{ stData?.dueDate }}</span>
                          </td>
                          <td class="two-column-lay header">{{ "statementDisplay.trans_type_label" | cxTranslate }}</td>
                          <td class="two-column-lay">
                            <span>{{ stData?.transType }}</span>
                          </td>
                          <td class="two-column-lay header">{{ "statementDisplay.document_number_label" | cxTranslate }}</td>
                          <td class="two-column-lay">
                            <span>{{ stData?.documentNumber }}</span>
                          </td>
                          <td class="two-column-lay header">{{ "statementDisplay.original_amount_label" | cxTranslate }}</td>
                          <td class="two-column-lay">
                                    <span>
                                      <span *ngIf="checkNegativeValue(stData)">(</span>
                                      {{ stData?.originalAmount | number:"1.2-2" }}
                                      <span *ngIf="checkNegativeValue(stData)">)</span>
                                    </span>
                          </td>
                          <td class="two-column-lay header">
                            {{ "statementDisplay.amount_due_label" | cxTranslate }}
                          </td>
                          <td class="two-column-lay">
                                <span>
                                  <span *ngIf="checkNegativeValue(stData)">(</span>
                                  {{ stData?.amountDue | number: "1.2-2" }}
                                  <span *ngIf="checkNegativeValue(stData)">)</span>
                                </span>
                          </td>
                          <td class="two-column-lay header">{{ "statementDisplay.currency_label" | cxTranslate }}</td>
                          <td class="two-column-lay">
                            <span>{{ stData?.currency }}</span>
                          </td>
                          <td class="two-column-lay header">{{ "statementDisplay.terms_of_payment_label"| cxTranslate }}</td>
                          <td class="two-column-lay">
                            <span>{{ stData?.termsOfPayment }}</span>
                          </td>
                        </tr>
                      </table>
                    </section>
                  </section>
                  <table class="sub_total lower-section" aria-describedby="amountTable">
                    <tr class="sample-header">
                      <th scope="col"></th>
                      <th scope="col"></th>
                    </tr>
                    <tbody>
                    <tr class="non-res even" role="row">
                      <td class="hide invisible"></td>
                      <td class="hide invisible"></td>
                      <td class="hide invisible"></td>
                      <td class="hide invisible"></td>
                      <td colspan="4" class="comp-nam text-left">{{ "statementDisplay.sanofi_name" | cxTranslate }}</td>
                      <td class="tot tot-Styling text-left px-0">
                        <span *ngIf="checkNegativeValue(allStatementData?.amountDueTotal,true)">(</span>
                        {{ allStatementData?.amountDueTotal | formatNegative | number: "1.2-2" }}
                        <span *ngIf="checkNegativeValue(allStatementData?.amountDueTotal, true)">)</span>
                      </td>
                      <td class="cad cad-Styling px-0">
                        <span>{{ "statementDisplay.currency_symbol" | cxTranslate }}</span>
                      </td>
                      <td class="sep-Td"></td>
                    </tr>
                    </tbody>
                  </table>
                </section>
              </section>
              <section class="row spl-ny lower-section px-3" id="lower-section">
                @if (!!allStatementData) {
                  <section class="col-xs-6 col-sm-6 col-md-6 statement-address statement-dialog__text">
                    <h3 class="pl-0">{{ 'statementDisplay.billing_address_label' | cxTranslate }}</h3>
                    <p>{{ allStatementData?.soldToAddress?.companyName }}</p>
                    <p>
                      {{ allStatementData?.soldToAddress?.line1 | uppercase }}
                      {{ allStatementData?.soldToAddress?.line2 | uppercase }}
                    </p>
                    <p>
                      {{ allStatementData?.soldToAddress?.town | uppercase }} &nbsp;
                      {{ allStatementData?.soldToAddress?.region?.isocodeShort | uppercase }}
                      &nbsp;
                      {{ allStatementData?.soldToAddress?.postalCode | uppercase }}
                    </p>
                  </section>
                  <section class="col-xs-6 col-sm-6 col-md-6 analytics">
                    <h3>{{ "statementDisplay.analysis_account_label" | cxTranslate }}</h3>
                    <section class="">
                      <table class="table table-analysis statement-dialog__text" aria-describedby="statementTable">
                        <thead>
                        <tr>
                          <th scope="col" colspan="3" class="p-0"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td>{{ "statementDisplay.current_account_label"| cxTranslate }}</td>
                          <td>{{ "statementDisplay.currency_symbol" | cxTranslate }}</td>
                          <td class="text-right">
                            <span *ngIf="checkNegativeValue(allStatementData?.currentPaymentAmountTotal, true)">(</span>
                            {{ allStatementData?.currentPaymentAmountTotal | formatNegative | number: "1.2-2" }}
                            <span *ngIf="checkNegativeValue(allStatementData?.currentPaymentAmountTotal,true)">)</span>
                          </td>
                        </tr>

                        <tr>
                          <td>{{ "statementDisplay.thirty_days_label" | cxTranslate }}</td>
                          <td>{{ "statementDisplay.currency_symbol" | cxTranslate }}</td>
                          <td class="text-right">
                            <span *ngIf="checkNegativeValue(allStatementData?.last30DaysPaymentAmountTotal,  true)">(</span>
                            {{ allStatementData?.last30DaysPaymentAmountTotal | formatNegative | number: "1.2-2" }}
                            <span *ngIf="checkNegativeValue(allStatementData?.last30DaysPaymentAmountTotal, true)">)</span>
                          </td>
                        </tr>

                        <tr>
                          <td>{{ "statementDisplay.sixty_days_label" | cxTranslate }}</td>
                          <td>{{ "statementDisplay.currency_symbol" | cxTranslate }}</td>
                          <td class="text-right">
                            <span *ngIf="checkNegativeValue(allStatementData?.last60DaysPaymentAmountTotal,true )">(</span>
                            {{ allStatementData?.last60DaysPaymentAmountTotal | formatNegative | number: "1.2-2" }}
                            <span *ngIf="checkNegativeValue(allStatementData?.last60DaysPaymentAmountTotal,true)">)</span>
                          </td>
                        </tr>

                        <tr>
                          <td>{{ "statementDisplay.ninety_days_label" | cxTranslate }}</td>
                          <td>{{ "statementDisplay.currency_symbol" | cxTranslate }}</td>
                          <td class="text-right">
                            <span *ngIf="checkNegativeValue(allStatementData?.last90DaysPaymentAmountTotal, true)">(</span>
                            {{ allStatementData?.last90DaysPaymentAmountTotal| formatNegative| number: "1.2-2" }}
                            <span *ngIf="checkNegativeValue(allStatementData?.last90DaysPaymentAmountTotal, true)">)</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </section>
                  </section>
                }
              </section>
              <section class="float-right-logo logo-account-bottom pasteur-logo lower-section" id="logo-section">
                <img src="img/vs-canada-sanofi-pasteur-logo.png" alt="sanofi-pastuer-logo"/>
              </section>
              <!--table ends-->
            </section>
          } @else {
            <cx-spinner />
          }
        </section>
      </section>
    </section>
  </div>
</section>
